var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"积分规则","visible":_vm.visible,"close-on-click-modal":false,"close-on-press-escape":false,"append-to-body":"","width":"600px"},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.close}},[_c('div',{staticClass:"rule-content"},[_vm._v(" "+_vm._s(_vm.pointsRule)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }